//****************************************
// Website scripts
//****************************************
'use strict';

/** 
* Handle Tab Click
*/
const handleTabClick = () => {
  // init
  const tabs = document.querySelectorAll('.js-tab');

  tabs.forEach(tab => {
    tab.onclick = (event) => {
      event.target.parentNode.parentNode.setAttribute('data-tab', event.target.classList[0]);
    }
  })
}

/** 
* Handle Headroom
*/
const handleHeaderScroll = () => {
  const header = document.querySelector('.js-header[data-style="sticky"]');
  if (header) {
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
    scrollPos > 50 ? header.classList.add('is-sticky') : null
    window.addEventListener('scroll', (event) => {
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollPos > 100) {
        header.classList.add('is-sticky');
      } else if (scrollPos < 1){
        header.classList.remove('is-sticky');
      }
    }, false);
  }
}


/** 
* Handle Load More
*/
const handleLoadMore = () => {
  // init
  const loadMoreBtn = document.querySelector('.js-load-more');

  if (loadMoreBtn && themeGlobal.lastPage) {
    loadMoreBtn.disabled = true;
    loadMoreBtn.classList.add('btn--disabled');
  }

  // event
  if (loadMoreBtn) {
    loadMoreBtn.onclick = (event) => {
      loadMorePosts(event.srcElement);
    }
  }
}

/** 
* Handle Image Gallery
*/
const handleImageGallery = () => {
  const galleryImages = document.querySelectorAll('.kg-gallery-image img');

  // Gallery style
  galleryImages.forEach(image => {
    image.setAttribute('alt', 'Gallery Image');
    var container = image.closest('.kg-gallery-image');
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = `${ratio} 1 0%`;
  })
}

/** 
* Handle Lightbox
*/
const handleLightbox = () => {
  if (!themeGlobal.imageLightbox) return

  const images = document.querySelectorAll('.kg-image-card img, .kg-gallery-card img');

  // Lighbox function
  images.forEach(image => {
    const link = image.parentNode.nodeName === 'A' ? image.parentNode.getAttribute('href') : '';
    var lightboxWrapper = link ? image.parentNode : document.createElement('a');

    lightboxWrapper.setAttribute('data-no-swup', '');
    lightboxWrapper.setAttribute('data-fslightbox', '');
    lightboxWrapper.setAttribute('href', image.src);
    lightboxWrapper.setAttribute('aria-label', 'Click for Lightbox');

    if (link) {
      var linkButton = document.createElement('a');
      linkButton.innerHTML = `<i class="icon icon-link icon--sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-link" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5" />
          <path d="M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5" />
        </svg>
      </i>`
      linkButton.setAttribute('class', 'image-link');
      linkButton.setAttribute('href', link);
      linkButton.setAttribute('target', '_blank');
      linkButton.setAttribute('rel', 'noreferrer noopener');
      lightboxWrapper.parentNode.insertBefore(linkButton, lightboxWrapper.parentNode.firstChild);
    } else {
      image.parentNode.insertBefore(lightboxWrapper, image.parentNode.firstChild);
      lightboxWrapper.appendChild(image);
    }
  });

  refreshFsLightbox();
}

/** 
* Handle Menu
*/
const handleMenu = () => {
  // menu
  const menu = document.querySelector('.js-menu');
  if (!menu) return; 
  
  // menu open
  const menuOpenBtn = document.querySelector('.js-menu-toggle');
  if (menuOpenBtn) {
    menuOpenBtn.onclick = (event) => {
      document.body.toggleAttribute('data-menu-open');
      document.querySelector(':root').style.setProperty('--global-header-height', `${document.querySelector('.header').offsetHeight}px`);
    }
  }

  // Click event outside menu and not menu open button
  window.addEventListener('click', (event) => {
    if (!event.target.closest('.js-menu') && !event.target.closest('.js-menu-toggle, .js-member-btn, .js-exclude')) {
      if(!['INPUT','TEXTAREA','SELECT'].includes(document.activeElement.tagName)){
        document.activeElement.blur();
      }
      document.body.removeAttribute('data-menu-open');
    }
  });
}

/** 
* Handle User Menu
*/
const handleUserMenu = () => {
  const memberBtn = document.querySelector('.js-member-btn');
  const memberMenu = document.querySelector('.js-member-menu');
  let isMemberFocus = false;
  if (memberBtn) {
    memberBtn.onfocus = (event) => {
      isMemberFocus=true;
      memberMenu.classList.add('is-active');
    }

    memberBtn.onblur = (event) => {
      isMemberFocus=false;
      memberMenu.classList.remove('is-active');
    }

    memberBtn.onclick = (event) => {
      !isMemberFocus ? memberMenu.classList.toggle('is-active')
                     : isMemberFocus = false;
    }
  }
}

/** 
* Handle Scroll Top
*/
const handleScrollTop = () => {
  const scrollTopBtn = document.querySelector('.js-scroll-top');
  if (scrollTopBtn) {
    scrollTopBtn.onclick = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }
}


/**
* Handle Keyboard events
*/
const handleKeyboardEvents = () => {
  // Key press event handling
  window.onkeydown = (evt) => {
    const sourceClass = evt.srcElement.className;

    switch(evt.key) {
      case 'Escape':
        removeClass('.js-menu', 'is-active');
        removeClass('.js-menu-toggle', 'is-active');
        document.activeElement.blur();
        document.body.removeAttribute('data-menu-open');
        break;
      default:
        break;// nothing to do
    }
  }
}

/**
* Handle Keyboard events
*/
const handleProgressBar = () => {
  const progressBar = document.querySelector('.progress-bar');

  if (progressBar) {
    window.addEventListener('scroll', (event) => {
      // Progressbar
      var scrollTop = document.querySelector('.post')["scrollTop"] ||
                      document.documentElement["scrollTop"] || 
                      document.body["scrollTop"];
  
      var scrollBottom = ( document.querySelector('.post')["scrollHeight"] ||
                          document.documentElement["scrollHeight"] ||
                          document.body["scrollHeight"] -
                          document.documentElement.scrollHeight);
  
      scrollPercent = Math.round(scrollTop / scrollBottom * 100) + "%";
      progressBar.style.setProperty("--scroll", scrollPercent);
    }, false);
  }
}

/** 
* Toggle Scheme
* @param
*/ 
const setTheme = (theme) => {
  document.documentElement.setAttribute('data-color-scheme', theme);
  localStorage.setItem('PREFERRED_COLOR_SCHEME', theme);
}

/** 
* Toggle Class
* @param: el_class
* @param: target_class
*/ 
const toggleClass = (el_class, target_class) => {
  const el = document.querySelector(el_class);
  if (el) el.classList.toggle(target_class);
}

/** 
* Add Class
* @param: el_class
* @param: target_class
*/ 
const addClass = (el_class, target_class) => {
  const el = document.querySelector(el_class);
  if (el) el.classList.add(target_class);
}

/** 
* Remove Class
* @param: el_class
* @param: target_class
*/ 
const removeClass = (el_class, target_class) => {
  const el = document.querySelector(el_class);
  if (el) el.classList.remove(target_class);
}

/** 
* Check if element in Viewport
* @param: class
*/ 
const isInViewport = (cls) => {
  let el = document.querySelector(cls);
  if (!el) return;

  let top = el.offsetTop;
  let left = el.offsetLeft;
  let width = el.offsetWidth;
  let height = el.offsetHeight;

  while(el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return(
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
}

/** 
* Load more posts
* @param: button
*/ 
const loadMorePosts = (button) => {
  // next link
  const nextPage = document.querySelector('link[rel=next]');
  themeGlobal.nextPageLink = nextPage && !themeGlobal.nextPageLink ? nextPage.getAttribute('href') : themeGlobal.nextPageLink;

  // Update current page value
  if (themeGlobal.nextPageLink && !themeGlobal.lastPage) {
    button ? button.classList.add('loading') : '';

    // Fetch next page content
    fetch(themeGlobal.nextPageLink).then(res => res.text())
    .then(text => new DOMParser().parseFromString(text, 'text/html'))
    .then(doc => {
      // Get posts
      const posts = doc.querySelectorAll('.js-post-card');
      const postContainer = document.querySelector('.post-feed');
      const nextPage = doc.querySelector('link[rel=next]');

      // Add each post to the page
      posts.forEach(post => {
        postContainer.appendChild(post);
      });

      // Update themeGlobalS
      themeGlobal.currentPage = themeGlobal.currentPage + 1;
      themeGlobal.nextPageLink =  nextPage ? nextPage.getAttribute('href') : '';
      themeGlobal.nextPage = themeGlobal.nextPageLink ? themeGlobal.nextPage + 1 : NaN;
      themeGlobal.lastPage = themeGlobal.currentPage === themeGlobal.maxPages ? true : false;

      // Disable button on last page
      if (button && themeGlobal.lastPage) {
        button.disabled = true;
        button.classList.add('btn--disabled');
      }

      button ? button.classList.remove('loading') : '';
    }).catch(function (err) {
      // There was an error
      console.warn('Something went wrong.', err);
    });
  }
}


/**
* Handle Author Filter
*/
const handleAuthorFilter = () => {
  // Get filter items and author cards
  const filterItems = document.querySelectorAll('.authors-filter li');
  const authorCards = document.querySelectorAll('.grid.authors .author-card');

  // Add click event to each filter item
  filterItems.forEach(item => {
    item.addEventListener('click', () => {
      // Remove 'selected' class from all items
      filterItems.forEach(i => i.classList.remove('selected'));

      // Add 'selected' class to clicked item
      item.classList.add('selected');

      // Get the filter letter
      const filterLetter = item.textContent.trim().toLowerCase();

      // Filter author cards
      authorCards.forEach(card => {
        const authorSlug = card.getAttribute('data-author');

        if (filterLetter === 'all') {
          // Show all cards
          card.style.display = '';
        } else {
          // Check if author slug starts with the filter letter
          if (authorSlug && authorSlug.startsWith(filterLetter)) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        }
      });
    });
  });
}

/**
* Senior contributor avatars: show the first two letters of the name when the
* profile image is missing or fails to load (broken URL, deleted asset, etc.).
*/
const handleAvatarFallbacks = () => {
  // Shared broken/missing-image → initials fallback used by senior cards,
  // the author profile page, and Our Team cards.
  // Hide the <img> until it loads so the browser’s broken-image chrome never
  // flashes as square corners on the circular disc.
  document.querySelectorAll('.js-senior-avatar, .js-author-avatar, .js-team-avatar').forEach(avatar => {
    const initialsEl = avatar.querySelector('.senior-card__initials, .author-profile__initials, .contributor-card__initials');
    const name = (avatar.dataset.name || '').trim();

    if (initialsEl) {
      initialsEl.textContent = name.slice(0, 2).toUpperCase();
    }

    const img = avatar.querySelector('img');
    if (!img) {
      avatar.classList.add('is-fallback');
      return;
    }

    const showFallback = () => {
      avatar.classList.remove('is-loading', 'is-loaded');
      avatar.classList.add('is-fallback');
    };

    const showImage = () => {
      avatar.classList.remove('is-loading', 'is-fallback');
      avatar.classList.add('is-loaded');
    };

    if (img.complete && img.naturalWidth > 0) {
      showImage();
      return;
    }

    if (img.complete && img.naturalWidth === 0) {
      showFallback();
      return;
    }

    avatar.classList.add('is-loading');
    img.addEventListener('load', showImage, { once: true });
    img.addEventListener('error', showFallback, { once: true });
  });
};

/**
* Contributors page section nav (Senior / All)
*/
const handleContributorsNav = () => {
  const nav = document.querySelector('.js-contributors-nav');
  if (!nav) return;

  const links = Array.from(nav.querySelectorAll('.contributors-nav__link'));
  const sections = links
    .map(link => document.getElementById(link.dataset.section))
    .filter(Boolean);

  if (!sections.length) return;

  const setActive = id => {
    links.forEach(link => {
      link.classList.toggle('is-active', link.dataset.section === id);
    });
  };

  links.forEach(link => {
    link.addEventListener('click', event => {
      const target = document.getElementById(link.dataset.section);
      if (!target) return;

      event.preventDefault();
      setActive(link.dataset.section);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${link.dataset.section}`);
    });
  });

  // Keep the active tab in sync while scrolling through the two collections
  const onScroll = () => {
    const marker = (parseFloat(getComputedStyle(document.documentElement)
      .getPropertyValue('--global-header-height')) || 72) + 48;
    let current = sections[0].id;

    sections.forEach(section => {
      if (section.getBoundingClientRect().top - marker <= 0) {
        current = section.id;
      }
    });

    setActive(current);
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  // Honour a deep link on first load
  const hash = window.location.hash.replace('#', '');
  if (hash && document.getElementById(hash)) {
    setActive(hash);
  }
};

/**
* Handle Contributors Directory (A–Z index + name search)
*/
const handleContributorsDirectory = () => {
  const root = document.querySelector('.js-contributors');

  if (!root) return;

  const searchInput = root.querySelector('.js-contributors-search');
  const filterButtons = Array.from(root.querySelectorAll('.js-contributors-filter button'));
  const cards = Array.from(root.querySelectorAll('.js-contributor'));
  const emptyState = root.querySelector('.js-contributors-empty');

  // Strip accents so a name like "Óscar" is still indexed under O
  const normalise = value => (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

  const initialOf = card => normalise(card.dataset.name).charAt(0);
  const available = new Set(cards.map(initialOf));

  let activeLetter = 'all';

  // Letters nobody is filed under stay in place but become inert
  filterButtons.forEach(button => {
    const letter = button.dataset.letter;

    if (letter !== 'all' && !available.has(letter)) {
      button.disabled = true;
    }
  });

  const applyFilters = () => {
    const query = normalise(searchInput ? searchInput.value : '');
    let visible = 0;

    cards.forEach(card => {
      const matchesLetter = activeLetter === 'all' || initialOf(card) === activeLetter;
      const matchesQuery = !query || normalise(card.dataset.name).includes(query);
      const show = matchesLetter && matchesQuery;

      card.hidden = !show;

      if (show) visible += 1;
    });

    if (emptyState) emptyState.hidden = visible !== 0;
  };

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (button.disabled) return;

      filterButtons.forEach(other => other.classList.remove('is-selected'));
      button.classList.add('is-selected');
      activeLetter = button.dataset.letter;
      applyFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  applyFilters();
}

/**
* Handle Republish Modal
*/
const handleRepublishModal = () => {
  const republishButton = document.querySelector('.js-republish-button');
  const republishModal = document.querySelector('.js-republish-modal');
  
  if (!republishButton || !republishModal) return;

  const closeButton = republishModal.querySelector('.js-republish-close');
  const overlay = republishModal.querySelector('.js-republish-overlay');
  const articleTitle = republishModal.querySelector('.republish-modal__article-title');
  const articleMeta = republishModal.querySelector('.republish-modal__article-meta');
  const htmlTab = republishModal.querySelector('.js-republish-tab[data-format="html"]');
  const plainTextTab = republishModal.querySelector('.js-republish-tab[data-format="plain"]');
  const contentArea = republishModal.querySelector('.js-republish-content');
  const copyButton = republishModal.querySelector('.js-republish-copy');

  // Format date to "Jan 6, 2026" format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    // Try to parse the date
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // If parsing fails, try to extract from text
      return dateString;
    }
    
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    
    return `${month} ${day}, ${year}`;
  };

  // Get article data
  const getArticleData = () => {
    const title = document.querySelector('.post-hero__title, h1')?.textContent?.trim() || '';
    
    // Extract author from post-info
    const authorElement = document.querySelector('.post-info .post-info__authors');
    const author = authorElement ? authorElement.textContent.trim() : '';
    
    // Extract date from post-info time element
    const timeElement = document.querySelector('.post-info time');
    let dateText = '';
    if (timeElement) {
      // Try to get datetime attribute first, then textContent
      const datetime = timeElement.getAttribute('datetime');
      if (datetime) {
        dateText = formatDate(datetime);
      } else {
        dateText = timeElement.textContent.trim();
      }
    }
    
    // Format article meta: "Title by Author on Date"
    let articleMeta = '';
    if (author) {
      articleMeta += ` by ${author}`;
    }
    if (dateText) {
      articleMeta += ` on ${dateText}`;
    }
    
    const date = document.querySelector('.post-date, time')?.textContent?.trim() || 
                 new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    
    // Get content and remove content-cta elements and article-content wrapper
    const contentElement = document.querySelector('.post.content, article.content');
    let content = '';
    
    if (contentElement) {
      // Clone the content to avoid modifying the original
      const clonedContent = contentElement.cloneNode(true);
      
      // Remove content-cta elements
      const contentCtaElements = clonedContent.querySelectorAll('.content-cta');
      contentCtaElements.forEach(el => el.remove());
      
      // Get innerHTML and remove article-content wrapper if it exists
      let htmlContent = clonedContent.innerHTML;
      
      // Remove article-content wrapper div if present
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      const articleContentWrapper = tempDiv.querySelector('.article-content');
      if (articleContentWrapper) {
        content = articleContentWrapper.innerHTML;
      } else {
        content = htmlContent;
      }
    }
    
    return { title, articleMeta, date, content };
  };

  // Generate HTML content
  const generateHTML = (data) => {
    const { title, date, content } = data;
    return `<h1>${escapeHtml(title)}</h1>
<p>${escapeHtml(date)}</p>
${content}`;
  };

  // Generate plain text content
  const generatePlainText = (data) => {
    const { title, date, content } = data;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    
    return `${title}\n\n${date}\n\n${plainText}`;
  };

  // Escape HTML
  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  // Update content based on active tab
  const updateContent = () => {
    const activeTab = republishModal.querySelector('.js-republish-tab.is-active');
    if (!activeTab) return;
    
    const format = activeTab.getAttribute('data-format');
    const articleData = getArticleData();
    
    // Update article info section
    if (articleTitle) {
      articleTitle.textContent = articleData.title;
    }
    if (articleMeta) {
      articleMeta.textContent = articleData.articleMeta || '';
    }
    
    // Update textarea content based on format
    if (format === 'html') {
      contentArea.textContent = generateHTML(articleData);
    } else {
      contentArea.textContent = generatePlainText(articleData);
    }
  };

  // Switch tabs
  const switchTab = (format) => {
    if (htmlTab) {
      htmlTab.classList.toggle('is-active', format === 'html');
    }
    if (plainTextTab) {
      plainTextTab.classList.toggle('is-active', format === 'plain');
    }
    updateContent();
  };

  // Open modal
  const openModal = () => {
    republishModal.setAttribute('open', '');
    updateContent();
    document.body.style.overflow = 'hidden';
  };

  // Close modal
  const closeModal = () => {
    republishModal.removeAttribute('open');
    document.body.style.overflow = '';
  };

  // Copy to clipboard
  const copyToClipboard = async () => {
    const text = contentArea.textContent;
    
    try {
      await navigator.clipboard.writeText(text);
      copyButton.textContent = 'Copied!';
      copyButton.style.opacity = '0.7';
      
      setTimeout(() => {
        copyButton.textContent = 'Copy to Clipboard';
        copyButton.style.opacity = '1';
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      contentArea.select();
      document.execCommand('copy');
      copyButton.textContent = 'Copied!';
      setTimeout(() => {
        copyButton.textContent = 'Copy to Clipboard';
      }, 2000);
    }
  };

  // Event listeners
  republishButton.addEventListener('click', (e) => {
    e.preventDefault();
    openModal();
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  if (overlay) {
    overlay.addEventListener('click', closeModal);
  }

  if (htmlTab) {
    htmlTab.addEventListener('click', () => switchTab('html'));
  }

  if (plainTextTab) {
    plainTextTab.addEventListener('click', () => switchTab('plain'));
  }

  if (copyButton) {
    copyButton.addEventListener('click', copyToClipboard);
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && republishModal.hasAttribute('open')) {
      closeModal();
    }
  });
}

/**
* Handle Republish Modal
*/
const handleDataLinks = () => {
  // Get all navigation links and sections
  const navLinks = document.querySelectorAll('.links-left a');
  const sections = document.querySelectorAll('[id]');

  // Function to remove 'selected' class from all links
  function removeAllSelected() {
    navLinks.forEach(link => link.classList.remove('selected'));
  }

  // Function to add 'selected' class to matching link
  function setActiveLink(hash) {
    removeAllSelected();
    const activeLink = document.querySelector(`.links-left a[href="${hash}"]`);
    if (activeLink) {
      activeLink.classList.add('selected');
    }
  }

  // Handle click events on navigation links
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);

      if (targetSection) {
        // Add selected class to clicked link
        setActiveLink(targetId);

        // Smooth scroll to section
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // Update URL without jumping
        history.pushState(null, null, targetId);
      }
    });
  });

  // Handle scroll events to highlight active section
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    // Debounce scroll event for better performance
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      let current = '';

      sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;

        // Check if section is in viewport (with offset for better UX)
        if (window.scrollY >= sectionTop - 200) {
          current = '#' + section.getAttribute('id');
        }
      });

      // Only update if there's a matching nav link
      if (current && document.querySelector(`.links-left a[href="${current}"]`)) {
        setActiveLink(current);
      }
    }, 100);
  });

  // Set initial active state based on URL hash
  if (window.location.hash) {
    setActiveLink(window.location.hash);
  }
}


/**
* Open external links in a new window
*/
const handleExternalLinks = () => {
  const currentOrigin = window.location.origin;
  document.querySelectorAll('a[href]').forEach(link => {
    try {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
        return;
      }
      const url = new URL(link.href, window.location.href);
      if (url.origin !== currentOrigin) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      // Invalid URL, skip
    }
  });
};

/** 
* DOM Loaded event
*/ 
const pageLoaded = () => {
  document.body.classList.remove('loading');
  fitvids();
  handleTabClick();
  handleHeaderScroll();
  handleLoadMore();
  handleImageGallery();
  handleLightbox();
  handleMenu();
  handleUserMenu();
  handleScrollTop();
  handleKeyboardEvents();
  handleProgressBar();
  handleAuthorFilter();
  handleAvatarFallbacks();
  handleContributorsNav();
  handleContributorsDirectory();
  handleRepublishModal();
  handleDataLinks();
  handleExternalLinks();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  pageLoaded();
} else {
  document.addEventListener('DOMContentLoaded', pageLoaded);
}
